import { buildUrl } from ".";
import { urlLanguageParam } from "./http";

export default (action: any = "") => {
  // @ts-ignore
  // (window.adsbygoogle = window.adsbygoogle || []).push({});
  let url = buildUrl(import.meta.env.VITE_LOG_URL, {
    action: action,
    ch: LocalStorage.getItem("ch"),
    lan: urlLanguageParam,
    page: window.location.hash.substring(2),
  });
  fetch(url, { method: "GET" });
};
